import './DirAccessController.less';
import React, { useEffect } from "react";
import { Button, message, Modal, Table, Tooltip } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import { dirHandleCenter } from "@/common/services/DirHandleCenter";
import CustomEvents from "@/common/constants/customEvents";
import eventBus from "@/common/services/eventBus";
import { reportAddDirHandleFailed } from "@/common/utils/report";


function DirAccessController() {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [dirNameList, setDirNameList] = React.useState<string[]>([]);

    useEffect(() => {
        eventBus.on(CustomEvents.DIR_HANDLE_CHANGE, () => {
            const dirHandles = dirHandleCenter.dirHandles;
            const names = dirHandles.map(dirHandle => dirHandle.name);
            setDirNameList(names);
        })

        return () => {
            eventBus.off(CustomEvents.DIR_HANDLE_CHANGE, () => {

            })
        }
    }, [])


    const handleAddDir = async () => {
        try {
            const dirHandle = await (window as any).showDirectoryPicker({ mode: 'readwrite' });
            if (dirHandle) {
                dirHandleCenter.addDirHandle(dirHandle);
                message.success('添加目录授权成功，可以点击【查看已添加目录授权】查看和删除所有授权');
            }
        }
        catch (err) {
            console.error(err);
            message.error('添加目录授权失败');
            reportAddDirHandleFailed(err + '');
        }

    }

    const handleDirControll = () => {
        setIsModalOpen(true);
    }

    const handleRemove = (e: any) => {
        const index = Number(e.currentTarget.getAttribute('data-index'));
        dirHandleCenter.remove(index);
        dirNameList.splice(index, 1);
        setDirNameList([...dirNameList]);
    }

    const dataSource = dirNameList.map((dirName: string, index) => {
        return {
            dirName
        }
    })

    const columns = [
        {
            title: '目录名称',
            dataIndex: 'dirName',
            key: 'dirName',
        },
        {
            title: '操作',
            key: 'action',
            render: (text: any, item: { dirName: string }, index: number) => (
                <div className='option-btn-container'>
                    <Button data-index={index} size='small' shape="circle" icon={<DeleteOutlined />} onClick={handleRemove} />
                </div>
            ),
        },
    ]
    return (
        <div>
            <Button onClick={handleDirControll}>查看已添加目录授权({dirNameList.length})</Button>
            <Tooltip placement="bottom" title="授权目录后，系统在批量替换该目录下的图片时将自动获取访问权限，无需对每个文件单独授权。在关闭当前页面后，自动释放访问权限，无需担心权限泄漏问题。" arrow={true}>
                <Button className="add-dir-btn" type="primary" onClick={handleAddDir}>添加目录授权</Button>
            </Tooltip>
            <Modal
                title="目录授权管理"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
            >
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="path"
                />
            </Modal>
        </div>

    )
}

export default React.memo(DirAccessController);